import { Colors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function ArrowLeft({
  width = 18,
  height = 18,
  fill = Colors.gray700,
  ...props
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.52972 9.56303L9.40665 13.44C9.51815 13.5515 9.57321 13.682 9.57184 13.8315C9.57034 13.981 9.51147 14.1139 9.39522 14.2303C9.27884 14.3389 9.14709 14.3952 8.99996 14.399C8.85284 14.4029 8.72109 14.3467 8.60472 14.2303L3.84953 9.47509C3.77928 9.40484 3.72978 9.33078 3.70103 9.2529C3.67215 9.17503 3.65771 9.0909 3.65771 9.00053C3.65771 8.91015 3.67215 8.82603 3.70103 8.74815C3.72978 8.67028 3.77928 8.59622 3.84953 8.52597L8.60472 3.77078C8.70859 3.6669 8.83721 3.61378 8.99059 3.6114C9.14396 3.60903 9.27884 3.66215 9.39522 3.77078C9.51147 3.88715 9.56959 4.02078 9.56959 4.17165C9.56959 4.32265 9.51147 4.45634 9.39522 4.57272L5.52972 8.43803H14.0625C14.2221 8.43803 14.3557 8.4919 14.4633 8.59965C14.5711 8.70728 14.625 8.8409 14.625 9.00053C14.625 9.16015 14.5711 9.29378 14.4633 9.4014C14.3557 9.50915 14.2221 9.56303 14.0625 9.56303H5.52972Z"
        fill={fill}
      />
    </Svg>
  );
}
